import React, { useEffect } from "react"
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet"
import L from "leaflet"
import "leaflet/dist/leaflet.css"
import "leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.css"
import "leaflet-defaulticon-compatibility"

const LeafletMap = () => {
  const markers = [
    { id: 1, position: [28.98779369472416, 79.41408556756232], popup: "Bhagwati Products Ltd, Rudrapur, Uttarakhand" },
    { id: 2, position: [28.110405194835824, 76.80305408103402], popup: "Bhagwati Products Ltd, Tapukara, Rajasthan" },
    { id: 3, position: [17.201506654256143, 78.4925512725612], popup: "Bhagwati Products Limited, Telangana" },
    { id: 4, position: [28.639029050691835, 77.5035066802406], popup: "Bhagwati Products Limited, Greater Noida, UP" },
  ]

  const orangeIcon = new L.Icon({
    iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-orange.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
  });
  useEffect(() => {
    // Custom icon setup
    delete L.Icon.Default.prototype._getIconUrl
    L.Icon.Default.mergeOptions({
      iconRetinaUrl: "/marker-icon-2x.png",
      iconUrl: "/marker-icon.png",
      shadowUrl: "/marker-shadow.png",
    })
  }, [])

  return (
    <div className="map-container relative z-10 mt-16 rounded-lg overflow-hidden shadow-lg">
      <MapContainer
        center={[25.8224, 78.5303]}
        zoom={5}
        style={{ height: "600px", width: "100%" }}
        scrollWheelZoom={false}
      >
        <TileLayer
          url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
        />
        {markers.map((marker) => (
          <Marker 
            key={marker.id} 
            position={marker.position}
            icon={orangeIcon}
          >
            <Popup>
              <div className="text-center">
                <h3 className="font-bold mb-2">{marker.popup}</h3>
                <button className="bg-orange-500 hover:bg-orange-700 text-white font-bold py-2 px-4 rounded">
                  View Details
                </button>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  )
}

export default LeafletMap